import request from '@/utils/request'

// 获取班级列表
export function getGradeList() {
  return request({
    url: '/grades/list',
    method: 'get'
  })
}

// 获取教师创建的班级列表
export function getTeacherGradeList() {
  return request({
    url: '/grades/teacher',
    method: 'get'
  })
}

// 获取班级详情
export function getGradeDetail(id) {
  return request({
    url: `/grades/${id}`,
    method: 'get'
  })
}

// 创建班级
export function createGrade(data) {
  return request({
    url: '/grades',
    method: 'post',
    data
  })
}

// 更新班级
export function updateGrade(id, data) {
  return request({
    url: `/grades/${id}`,
    method: 'put',
    data
  })
}

// 删除班级
export function deleteGrade(id) {
  return request({
    url: `/grades/${id}`,
    method: 'delete'
  })
}

// 获取班级学生列表
export function getStudentsByClassId(classId) {
  return request({
    url: `/grades/${classId}/students`,
    method: 'get'
  })
}
